// imports section Start

import React, { useState, useContext } from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import { ThemeProvider, CssBaseline, Box, useMediaQuery } from "@mui/material";
import { lightTheme, darkTheme } from "../../assets/styles/Theme";
import { useSelector } from "react-redux";
import ProtectedRoute from "../../utils/common/ProtectedRoute";

// Import all your components
import HideSidebar from "../../utils/common/HideSidebar";
import Sidebar from "./sidebar";
import Login from "../../features/main/Login";
import Home from "../../features/dashboard/Home";
import ViewLocations from "../../features/location/ViewLocations";
import AddLocations from "../../features/location/AddLocations";
import ViewParameters from "../../features/parameters/ViewParameters";
import SetupParameters from "../../features/parameters/SetupParameters";
import DayendProcess from "../../features/dayend/DayendProcess";
import ViewUserGroups from "../../features/usergroups/ViewUserGroups";
import AddUserGroups from "../../features/usergroups/AddUserGroups";
import ViewUsers from "../../features/users/ViewUsers";
import AddUsers from "../../features/users/AddUsers";
import UpdateSession from "../../features/users/UpdateSession";
import ViewUserLogs from "../../features/users/ViewUserLogs";
import UpdateAccount from "../../features/users/UpdateAccount";
import MapLocations from "../../features/users/MapLocations";
import ViewTaxpage from "../../features/tax/ViewTaxpage";
import MapReports from "../../features/reports/MapReports";
import PaymentHistory from "../../features/accounts/PaymentHistory";
import BillingSchedule from "../../features/accounts/BillingSchedule";
import LicenseAddOns from "../../features/accounts/LicenseAddOns";
import LicenseDetails from "../../features/accounts/LicenseDetails";
import Terms from "../../features/accounts/Terms";
import Policies from "../../features/accounts/Policies";
import RenewLicense from "../../features/accounts/RenewLicense";
import ViewShop from "../../features/shops/ViewShop";
import AddShop from "../../features/shops/AddShop";
import CreateTaxandCharges from "../../features/tax/CreateTaxandCharges";
import MapTaxandCharges from "../../features/tax/MapTaxandCharges";
import MapPayments from "../../features/payments/MapPayments";
import MapCurrency from "../../features/payments/MapCurrency";
import ChangePassword from "../../features/users/ChangePassword";
import MapPrivileges from "../../features/privilages/MapPrivileges";
import Viewcompany from "../../features/company/Viewcompany";
import Managecompany from "../../features/company/Managecompany";
import ChangeUserPassword from "../../features/users/ChangeUserPassword";
import SelectReports from "../../features/reports/SelectReports";
import MapUsers from "../../features/users/MapUsers";
import ViewMapUsers from "../../features/users/ViewMapUsers";
import GenerateQR from "../../features/shops/GenerateQR";
import PaymentDetails from "../../features/accounts/PaymentDetails";
import CustomizedDialogs from "./CustomizedDialogs";
import MyProfile from "../../features/users/MyProfile";
import ModuleTransfer from "../../features/main/ModuleTransfer";
import CreateLicenseAddOns from "../../features/accounts/CreateLicenseAddOns";
import UpdatedLicAddOns from "../../features/accounts/UpdatedLicAddOns";
import UpdateLicenseAddOns from "../../features/accounts/UpdateLicenseAddOns";
import ViewEmailsetup from "../../features/emailsetup/ViewEmailsetup";
import AddEmailsetup from "../../features/emailsetup/AddEmailsetup";
import ViewSmssetup from "../../features/smssetup/ViewSmssetup";
import AddSmssetup from "../../features/smssetup/AddSmssetup";
// imports section End

const PageRouting = () => {
  // Hooks start
  const [mode, setMode] = React.useState("light");
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  // Hooks end

  // Handlers start
  const theme = mode === "light" ? lightTheme : darkTheme;
  const toggleTheme = () => {
    setMode((prevMode) => (prevMode === "light" ? "dark" : "light"));
  };

  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isTablet = useMediaQuery(theme.breakpoints.between("md", "lg"));
  const hideSidebar = HideSidebar();

  const isGuestPage = location.pathname.startsWith("/Guest");
  const isGuestCheckoutPage = location.pathname.startsWith("/GuestCheckout");
  // Handlers end

  // const accessRights = useSelector((state) => state.accessRights);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {!hideSidebar && (
        <Sidebar
          mode={mode}
          toggleTheme={toggleTheme}
          isMobile={isMobile}
          isSidebarOpen={isSidebarOpen}
          setSidebarOpen={setSidebarOpen}
        />
      )}
      <Box sx={{ paddingBottom: isGuestPage || isGuestCheckoutPage ? 7 : 0 }}>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/Login" element={<Login />} />
          <Route path="/home" element={<Home />} />
          <Route path="/AddLocations" element={<AddLocations />} />
          <Route path="/ViewLocations" element={<ViewLocations />} />
          <Route path="/SetupParameters" element={<SetupParameters />} />
          <Route path="/ViewParameters" element={<ViewParameters />} />
          <Route path="/DayendProcess" element={<DayendProcess />} />
          <Route path="/ViewUserGroups" element={<ViewUserGroups />} />
          <Route path="/AddUserGroups" element={<AddUserGroups />} />
          <Route path="/ViewUsers" element={<ViewUsers />} />
          <Route path="/AddUsers" element={<AddUsers />} />
          <Route path="/UpdateSession" element={<UpdateSession />} />
          <Route path="/ViewUserLogs" element={<ViewUserLogs />} />
          <Route path="/UpdateAccount" element={<UpdateAccount />} />
          <Route path="/MapLocations" element={<MapLocations />} />
          <Route path="/MapReports" element={<MapReports />} />
          <Route path="/PaymentHistory" element={<PaymentHistory />} />
          <Route path="/Paymentdetails" element={<PaymentDetails />} />
          <Route path="/BillingSchedule" element={<BillingSchedule />} />
          <Route path="/LicenseAddOns" element={<LicenseAddOns />} />
          <Route path="/AddLicenseAddOns" element={<CreateLicenseAddOns />} />
          <Route path="/LicenseDetails" element={<LicenseDetails />} />
          <Route path="/Terms" element={<Terms />} />
          <Route path="/Policies" element={<Policies />} />
          <Route path="/RenewLicense" element={<UpdatedLicAddOns />} />
          <Route path="/UpdateLicense" element={<UpdateLicenseAddOns />} />

          <Route path="/ViewShop" element={<ViewShop />} />
          <Route path="/AddShop" element={<AddShop />} />
          <Route path="/Createtaxcharge" element={<CreateTaxandCharges />} />
          <Route path="/ViewtaxCharges" element={<ViewTaxpage />} />
          <Route path="/generateQR" element={<GenerateQR />} />
          <Route path="/MapTaxandCharges" element={<MapTaxandCharges />} />
          <Route path="/MapPayments" element={<MapPayments />} />
          <Route path="/MapCurrency" element={<MapCurrency />} />
          <Route path="/ChangePassword" element={<ChangePassword />} />
          <Route path="/ChangeUserPassword" element={<ChangeUserPassword />} />
          <Route path="/MapPrivileges" element={<MapPrivileges />} />
          <Route path="/Viewcompany" element={<Managecompany />} />
          {/* I removed the viewCompany page and instead of that i Put ManageCompany page  */}
          <Route path="/Managecompany" element={<Managecompany />} />
          <Route path="/report" element={<SelectReports />} />
          <Route path="/MapUsers" element={<MapUsers />} />
          <Route path="/ViewMapUsers" element={<ViewMapUsers />} />
          <Route path="/View" element={<CustomizedDialogs />} />
          <Route path="/myprofile" element={<MyProfile />} />
          <Route path="/ModuleTransfer" element={<ModuleTransfer />} />
          <Route path="/Vemailsetup" element={<ViewEmailsetup />} />
          <Route path="/emailsetup" element={<AddEmailsetup />} />
          <Route path="/smssetup" element={<ViewSmssetup />} />
          <Route path="/Vsmssetup" element={<AddSmssetup />} />
        </Routes>
      </Box>
      {(isGuestPage || isGuestCheckoutPage) && <></>}
    </ThemeProvider>
  );
};

export default PageRouting;
